<div class="emds">
  <mat-form-field appearance="outline" class="emds-find-control" (click)="findControlClicked($event)">
    <mat-chip-list #chipList [disabled]="disabled" matPrefix>
      <mat-chip [disabled]="disabled" [selectable]="selectable" *ngIf="loadingItems || loadingConfig">
        <ap-spinner size="1"></ap-spinner>
      </mat-chip>
      <ng-container *ngIf="!loadingConfig && !loadingItems">
        <mat-chip class="mat-chip-counter" *ngIf="!singleSelect && autoCompleteOpen">
            {{'+'+chips.length}}
        </mat-chip>
        <mat-chip *ngFor="let chip of chips"
                  (click)="findControlClicked($event)"
                  [disabled]="disabled"
                  [selectable]="selectable"
                  [removable]="removable"
                  [hidden]="!singleSelect && autoCompleteOpen"
                  (removed)="removeChip(chip)">
          <div class="chip-name-container">
            {{getChipDisplayName(chip)}}
          </div>
          <button matChipRemove *ngIf="removable && !disabled">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
      </ng-container>
    </mat-chip-list>
    <input
        placeholder="{{this.chips && this.chips.length < 1 ? this.placeHolder : ''}}"
        [readonly]="disabled"
        #chipInput
        [formControl]="formControl"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="addOnBlur"
        [matAutocomplete]="auto"
        type="text"
        id="{{baseId}}-input"
        class="emds-find-control-text-input">
    <mat-autocomplete class="emds"
                      #auto="matAutocomplete"
                      (opened)="onAutoCompleteOpen()"
                      (closed)="onAutoCompleteClose()">
                      <mat-option *ngIf="loadingData" class="loading-option" [disabled]="true">
                        <ap-spinner size="2"></ap-spinner>
                      </mat-option>
                      <mat-optgroup class="find-control-dropdown-group"
                                    [hidden]="loadingData"
                                    *ngFor="let group of autocompleteGroups | async"
                                    [label]="group.Name">
                        <mat-option *ngFor="let option of group.ItemList"
                                    [value]="option"
                                    (click)="preventDefault($event)"
                                    class="default-cursor">
                          <div class="flex-row center-v">
                            {{getAutocompleteDisplayName(option)}}
                            <mat-icon matListIcon class="clickable flex-pull-right"
                                      (click)="removeChip(option)">cancel
                            </mat-icon>
                          </div>
                        </mat-option>
                        <mat-option *ngIf="!group.ItemList.length && !group.isCollapsed" [disabled]="true" translate>
                          No items available
                        </mat-option>
                      </mat-optgroup>
    </mat-autocomplete>
    <mat-icon matSuffix class="emds-find-control-icon clickable" (click)="openModal($event)">search</mat-icon>
  </mat-form-field>
</div>
